import { createContext, useContext, type ReactNode } from "react";
import { defaultSiteNav, type SiteNavLink } from "./siteNav";

const SiteNavContext = createContext<SiteNavLink[]>(defaultSiteNav());

export function SiteNavProvider({ value, children }: { value: SiteNavLink[]; children: ReactNode }) {
  return <SiteNavContext.Provider value={value}>{children}</SiteNavContext.Provider>;
}

export function useSiteNav(): SiteNavLink[] {
  return useContext(SiteNavContext);
}
